import { FC } from 'react'

import { PrimaryLabel } from '../PrimaryLabel'

export const PRE_RELEASE_LABEL_TEXT = 'Pre-release'

export const PreReleaseLabel: FC = () => (
  <PrimaryLabel text={PRE_RELEASE_LABEL_TEXT} />
)
